import React, { useCallback, useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { CloseIconWrap, Content, Header, Main, Mask, ModalStyle, Title } from './atoms'
import { ModalProps } from './types'
import ModalManager from './modal-manager'
import { CloseIcon } from './close-icon'
import { TransparentCloseIcon } from './transparent-close-icon'

const ANIMATION_DELAY = 200
const modalManager = new ModalManager()

export const Modal = (props: ModalProps) => {
  const {
    children,
    visible,
    title,
    top,
    right,
    left,
    bottom,
    onCancel,
    // onOk,
    destroy,
    autoClose,
    zIndex = 10001,
    maskClosable = true,
    // canEnterClose = true,
    width,
    bodyStyle,
    backgroundColor,
    color,
    isTransparent = false,
    titleCenter = false,
    titleFontSize = 14,
  } = props
  const [isShowModal, setIsShowModal] = useState(true)
  const container = React.useRef<HTMLElement | null>(null)
  const [isWindow, setIsWindow] = useState(false)
  const openTimer = useRef<ReturnType<typeof setTimeout> | undefined>()
  const closeTimer = useRef<ReturnType<typeof setTimeout> | undefined>()

  useEffect(() => {
    if (container.current === null) {
      container.current = document.createElement('div')
    }
    setIsWindow(true)
  }, [])

  const handleOpen = useCallback(() => {
    openTimer.current = setTimeout(() => {
      setIsShowModal(true)
      modalManager.add(container.current!)
    }, 100)
  }, [])

  const handleClose = useCallback(() => {
    // 在关闭动画结束后再清除元素
    closeTimer.current = setTimeout(() => {
      setIsShowModal(false)
      modalManager.remove(container.current!)
      destroy?.()
    }, ANIMATION_DELAY)
  }, [destroy])

  useEffect(() => {
    if (visible) {
      handleOpen()
    } else {
      handleClose()
    }
  }, [handleClose, handleOpen, visible])

  useEffect(() => {
    const timer = setTimeout(() => {
      autoClose?.()
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [autoClose])

  useEffect(() => {
    return () => {
      clearTimeout(openTimer.current)
      clearTimeout(closeTimer.current)
    }
  }, [])

  const handleMaskClick = () => {
    if (!maskClosable) return
    onCancel?.()
  }

  const modalElement = (
    <ModalStyle $zIndex={zIndex!} $visible={visible}>
      <Mask onClick={handleMaskClick} $delay={ANIMATION_DELAY}></Mask>
      <Content
        top={top}
        right={right}
        left={left}
        bottom={bottom}
        minWidth={width}
        $backgroundColor={backgroundColor}
        color={color}
        $visible={visible}
        $delay={ANIMATION_DELAY}
        $isTransparent={isTransparent}
      >
        <Header>
          <Title $titleFontSize={titleFontSize} $titleCenter={titleCenter}>
            {title || ''}
          </Title>
          <CloseIconWrap onClick={onCancel} $isTransparent={isTransparent}>
            {isTransparent ? <TransparentCloseIcon /> : <CloseIcon />}
          </CloseIconWrap>
        </Header>
        <Main style={bodyStyle}>{children}</Main>
      </Content>
    </ModalStyle>
  )

  return isShowModal && isWindow ? ReactDOM.createPortal(modalElement, document.body) : null
}
